<template>
  <div class="page-content">
    <page-template
      class="info-container"
      ref="scalesTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="editColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate,
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: '', prop: 'otherName', type: 'input', isFuzzy: true, placeholder: "请输入商品名称/条码"}
          ],
           complex:[
             {
               label: '类别',
               type: 'cascader',
               prop: 'goodsCategoryId',
               valueKey: 'value',
               data: [],
               span: 12,
               change: this.typeChange,
               url: api.archives.getCategoryTree,
             },
             {
               label: '评价星级',
               type: 'select',
               prop: 'supplierId',
               span: 12,
               data: [],
               url: api.archives.supplier,
             },
             {
              label: '选择日期:',
              prop: 'createDttms',
              type: 'datetimeRange',
              dateType: 'date',
              span: 24
            },
           ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
          },
          {
            label: '批量修改',
            code: 'batchUpdatePLU',
            callback: this.batchEdit
          },
        ],
        // 表格信息配置
        tableOptions: {
          showSelect: true,
          indexShow: true,//是否显示索引
          param: {pricingMethod: 30},
          columns: [
            {label: '商品图片', prop: 'goodsImageUrl', width: '120', align: 'center', type: 'image'},
            {label: '商品名称', prop: 'name', width: '120', align: 'center'},
            {
            label: '商品规格',
            prop: 'specs',
            width: '100',
            align: 'center'
          },
          {label: '姓名/昵称', prop: 'retailPrice', width: '120', align: 'center'},
          {label: '评价时间', prop: 'lastModifyDttm', width: '120', align: 'center'},
          {label: '评价星级', prop: 'pluCode', width: '120', align: 'center'},
          {label: '评价内容', prop: 'lastModifyBy', width: '120', align: 'center'},
          {
            label: '显示状态',
            prop: 'status',
            enumData:this.$utils.getCacheStatus('asGoods.status')
          },
          ],
          url: api.archives.goodsInfo
        },
        // 添加字段
        addColumns: {
          labelWidth: '350px',
          span: 24,
          columns: [
            {
              label: 'id',
              type: 'input',
              prop: 'id',
              hidden: true,
            },
            {
              label: '条码',
              type: 'select',
              prop: 'barCode',
              align: "center",
              data: [],
              url: api.archives.goodsInfo + '/no/plu/goods',
              param: {pricingMethod: 30}, // 称重商品
              labelKey: 'barCode',
              change: this.getGoodsName,
            },
            {
              label: '商品名称',
              type: 'input',
              prop: 'name',
              align: "center",
              disabled: true,
            },
            {
              label: 'PLU码',
              type: 'code',
              prop: 'pluCode',
              align: "center",
              url: api.archives.getPluCode,
              checkUrl: api.archives.verifyPluCode
            },
          ], // 表单label
          url: api.archives.goodsInfo + '/update/PLU'
        },
        // 编辑字段
        editColumns: {
          labelWidth: '350px',
          span: 24,
          columns: [
            {
              label: 'id',
              type: 'input',
              prop: 'id',
              hidden: true,
            },
            {
              label: '条码',
              type: 'select',
              prop: 'barCode',
              align: "center",
              data: [],
              url: api.archives.goodsInfo,
              param: {pricingMethod: 30}, // 称重商品
              labelKey: 'barCode',
              change: this.getGoodsName,
            },
            {
              label: '商品名称',
              type: 'input',
              prop: 'name',
              align: "center",
              disabled: true,
            },
            {
              label: 'PLU码',
              type: 'code',
              prop: 'pluCode',
              align: "center",
              url: api.archives.getPluCode,
              checkUrl: api.archives.verifyPluCode
            },
          ], // 表单label
          url: api.archives.goodsInfo
        },
        //批量修改
        batchTableOptions: {
          showSelect: true,
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: "品名",
              prop: "goodsName",
              width: "100",
              align: "center"
            },
            {
              label: "PLU码",
              prop: "pluCode",
              width: "100",
              align: "center",
              type: "input"
            },
            // {
            //   label: 'PLU码',
            //   type: 'code',
            //   prop: 'pluCode',
            //   align: "center",
            //   url: api.archives.getPluCode,
            //   checkUrl: api.archives.verifyPluCode
            // },
          ],
          url: api.archives.goodsInfo
        },
      };
    },
    created() {
    },
    methods: {
      getGoodsName(data) {
        let barCodeIds = this.addColumns.columns.filter(item => item.prop === 'barCode')[0].data;
        barCodeIds.forEach(item => {
          // data.barCode 存的是id
          if (item.id === data.barCode) {
            data.name = item.name;
          }
        });
      },
      //批量修改
      batchEdit() {
        let tableSelected = this.$refs.scalesTemplate.getTableSelectRow();
        if (tableSelected.length === 0) {
          this.$message({message: '请勾选数据后进行批量修改', type: 'warning'});
        } else {
          this.batchEditShow = true;
          this.batchUpDateList = tableSelected;
          this.$nextTick(() => {
            this.$refs["batchEdit"].getTableData()
          })
        }
      },
      selectSubmit() {
        this.$axios.fetchPost('/api/eros/as/asGoods/batch/update/PLU', {asGoodsList: this.batchUpDateList}).then(data => {
          if (data.code === 200) {
            if (data.data === true) {
              this.batchEditShow = false;
              this.$refs["scalesTemplate"].operationSuccess();
            }
          }
        })
      },
    }
  };
</script>

<style scoped>
  .priceEdit {
    margin-left: 10px;
    margin-bottom: 20px;
  }
  .batch-btn{
    margin-bottom: 10px;
  }
  .info-container{
    padding-top:0;
  }
</style>



// WEBPACK FOOTER //
// src/page/mall/setting/Evaluation.vue